import React, { createContext, useContext, useState, useEffect } from "react";

const STRINGS = {
  az: {
    app_name: "Infrastructure Supervision & Advisory",
    app_short: "YolTikinti",
    login: "Daxil ol",
    logout: "Çıxış",
    email: "Email",
    password: "Şifrə",
    login_btn: "Sistemə Daxil Ol",
    login_subtitle: "Yol tikintisi proseslərinin idarəetmə və nəzarət sistemi",
    dashboard: "İdarə paneli",
    projects: "Layihələr",
    queue: "Növbə",
    notifications: "Bildirişlər",
    contractors: "Podratçılar",
    users: "İstifadəçilər",
    norms: "DESN Normaları",
    correction_journal: "Korreksiya Jurnalı",
    reports: "Hesabatlar",
    audit: "Audit Log",
    tariffs: "Tariflər",
    new_project: "Yeni Layihə",
    new_stage: "Yeni Mərhələ",
    new_segment: "Yeni Hissə",
    new_inspection: "Yoxlanış sorğusu",
    site_cleaning: "Sahənin təmizlənməsi",
    fill_layers: "Dolğu qatları",
    road_base: "Asfalt yatağı",
    asphalt_coating: "Asfalt örtüyü",
    prime_coat: "Astar qatı (Prime coat)",
    base_asphalt: "Bitumlu təməl (Base)",
    tack_coat_1: "Yapışdırıcı qat 1 (Tack 1)",
    binder_course: "Əlaqələndirici lay (Binder)",
    tack_coat_2: "Yapışdırıcı qat 2 (Tack 2)",
    wearing_course: "Aşınma qatı (Wearing)",
    consumption_kg_m2: "Sərfiyyat (kq/m²)",
    asphalt_type: "Asfalt tipi",
    loss_pct_label: "İtki faizi (%)",
    emulsion_tons: "Emulsiya tonajı",
    pavement_layers_group: "Yol geyimi qatları (DESN-27)",
    earthwork_group: "Torpaq və baza işləri",
    length_m: "Uzunluq (m)",
    width_m: "En (m)",
    thickness_cm: "Qalınlıq (sm)",
    k_factor: "K əmsalı",
    density: "Sıxlıq (t/m³)",
    live_preview: "Canlı Hesablama",
    area: "Sahə",
    volume: "Həcm",
    tonnage: "Tonaj",
    workers: "İşçilər",
    machinery: "Texnika",
    materials: "Materiallar",
    total_cost: "Ümumi Dəyər",
    ok: "OK",
    not_ok: "NOT OK",
    comment: "Şərh",
    comment_required: "Şərh məcburidir",
    upload_media: "Media yüklə (şəkil/video)",
    submit: "Təsdiq et",
    save: "Yadda saxla",
    cancel: "Ləğv et",
    delete: "Sil",
    edit: "Redaktə",
    create: "Yarat",
    full_name: "Ad Soyad",
    position: "Vəzifə",
    role: "Rol",
    organization: "Təşkilat",
    name: "Ad",
    description: "Təsvir",
    deadline: "Son tarix",
    length_km: "Uzunluq (km)",
    no_data: "Məlumat tapılmadı",
    welcome: "Xoş gəldiniz",
    workflow: "İş axını",
    workflow_chain: "Yoxlanış zənciri",
    pending: "Gözləyir",
    approved: "Təsdiqləndi",
    rejected: "Rədd edildi",
    awaiting_team_lead: "Team Lead-in qərarını gözləyir",
    sub_request: "Sub-sorğu yarat",
    failed_role: "Uyğunsuz mərhələ",
    rating: "Reytinq",
    completion: "İcra %",
    total_projects: "Cəmi Layihələr",
    active_inspections: "Aktiv Yoxlanışlar",
    total_stages: "Cəmi Mərhələlər",
    total_contractors: "Podratçılar",
    contractor_rating: "Podratçı Reytinqi",
    media_archive: "Media Arxivi",
    technical_docs: "Texniki Sənədlər",
    segments: "Hissələr",
    stages: "Mərhələlər",
    inspections: "Yoxlanışlar",
    create_user: "İstifadəçi yarat",
    create_norm: "Norma yarat",
    table_code: "Cədvəl kodu",
    base_unit: "Baza vahidi",
    base_thickness: "Baza qalınlığı",
    additional_norm: "Əlavə norma",
    waiting_for_action: "Sizin aksiyanızı gözləyir",
    no_pending: "Gözləyən sorğu yoxdur",
    correction_required: "Korreksiya tələb olunur",
    overall_progress: "Ümumi gediş",
    sub_request_failed: "Geri qaytarılan iş",
    active_label: "AKTIV",
    my_segments: "Mənim hissələrim",
    my_projects: "Mənim layihələrim",
    km_completed: "Km icra olundu",
    corrections: "Korreksiyalar",
    my_rating: "Mənim Reytinqim",
    avg_segment_completion: "orta hissə icrası",
    recent_inspections_title: "Son Yoxlanışlar",
    loading: "Yüklənir...",
    active_queue: "Aktiv növbə",
    queue_waiting: "sorğu sizi gözləyir",
    projects_map: "Layihələr Xəritəsi",
    project_singular: "layihə",
    correction_zones: "korreksiya zonası",
    pending_inspection: "Yoxlanış gözləyir",
    correction_requests: "Korreksiya sorğuları",
    approved_label: "Təsdiqlənmiş",
    rejected_label: "Rədd edilmiş",
    total_estimate: "Cəmi smeta dəyəri",
    total_estimate_caption: "Bütün mərhələlər üzrə hesablanmış cəmi dəyər",
    total_estimate_short: "Cəmi smeta",
    pending_approval: "Təsdiq gözləyir",
    stage_types: "Mərhələ tipləri",
    stage_types_distribution: "Mərhələ tipi üzrə bölgü",
    active_segments: "Aktiv hissələr",
    role_label: {
      superadmin: "Super Admin",
      aayda_chairman: "AAYDA Sədri",
      aayda_tech_supervision: "AAYDA — Texniki Nəzarət",
      aayda_construction: "AAYDA — Tikinti",
      aayda_finance: "AAYDA — Maliyyə",
      aayda_curator: "AAYDA — Kurator",
      consulting_team_lead: "Team Lead",
      consulting_tech_office: "Texniki Ofis",
      consulting_inspector: "İnspektor",
      consulting_topographer: "Topoqraf",
      consulting_material_engineer: "Material Mühəndis",
      consulting_estimate_engineer: "Smeta Mühəndis",
      contractor: "Podratçı",
    },
  },
  en: {
    app_name: "Infrastructure Supervision & Advisory",
    app_short: "RoadOps",
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    login_btn: "Sign In",
    login_subtitle: "Construction process supervision and control system",
    dashboard: "Dashboard",
    projects: "Projects",
    queue: "Queue",
    notifications: "Notifications",
    contractors: "Contractors",
    users: "Users",
    norms: "DESN Norms",
    correction_journal: "Correction Journal",
    reports: "Reports",
    audit: "Audit Log",
    tariffs: "Tariffs",
    new_project: "New Project",
    new_stage: "New Stage",
    new_segment: "New Segment",
    new_inspection: "Inspection Request",
    site_cleaning: "Site Cleaning",
    fill_layers: "Fill Layers",
    road_base: "Road Base",
    asphalt_coating: "Asphalt Coating",
    prime_coat: "Prime Coat",
    base_asphalt: "Base Asphalt",
    tack_coat_1: "Tack Coat 1",
    binder_course: "Binder Course",
    tack_coat_2: "Tack Coat 2",
    wearing_course: "Wearing Course",
    consumption_kg_m2: "Consumption (kg/m²)",
    asphalt_type: "Asphalt Type",
    loss_pct_label: "Loss factor (%)",
    emulsion_tons: "Emulsion tonnage",
    pavement_layers_group: "Pavement Layers (DESN-27)",
    earthwork_group: "Earthwork & Base",
    length_m: "Length (m)",
    width_m: "Width (m)",
    thickness_cm: "Thickness (cm)",
    k_factor: "K factor",
    density: "Density (t/m³)",
    live_preview: "Live Preview",
    area: "Area",
    volume: "Volume",
    tonnage: "Tonnage",
    workers: "Workers",
    machinery: "Machinery",
    materials: "Materials",
    total_cost: "Total Cost",
    ok: "OK",
    not_ok: "NOT OK",
    comment: "Comment",
    comment_required: "Comment is required",
    upload_media: "Upload media (image/video)",
    submit: "Submit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    full_name: "Full Name",
    position: "Position",
    role: "Role",
    organization: "Organization",
    name: "Name",
    description: "Description",
    deadline: "Deadline",
    length_km: "Length (km)",
    no_data: "No data",
    welcome: "Welcome",
    workflow: "Workflow",
    workflow_chain: "Inspection Chain",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    awaiting_team_lead: "Awaiting Team Lead",
    sub_request: "Create Sub-request",
    failed_role: "Failed step",
    rating: "Rating",
    completion: "Progress %",
    total_projects: "Total Projects",
    active_inspections: "Active Inspections",
    total_stages: "Total Stages",
    total_contractors: "Contractors",
    contractor_rating: "Contractor Rating",
    media_archive: "Media Archive",
    technical_docs: "Technical Docs",
    segments: "Segments",
    stages: "Stages",
    inspections: "Inspections",
    create_user: "Create User",
    create_norm: "Create Norm",
    table_code: "Table code",
    base_unit: "Base unit",
    base_thickness: "Base thickness",
    additional_norm: "Additional norm",
    waiting_for_action: "Awaiting your action",
    no_pending: "No pending requests",
    correction_required: "Correction required",
    overall_progress: "Overall progress",
    sub_request_failed: "Returned work",
    active_label: "ACTIVE",
    my_segments: "My Segments",
    my_projects: "My Projects",
    km_completed: "Km Completed",
    corrections: "Corrections",
    my_rating: "My Rating",
    avg_segment_completion: "avg segment completion",
    recent_inspections_title: "Recent Inspections",
    loading: "Loading...",
    active_queue: "Active Queue",
    queue_waiting: "requests waiting for you",
    projects_map: "Projects Map",
    project_singular: "project",
    correction_zones: "correction zones",
    pending_inspection: "Pending Inspection",
    correction_requests: "Correction Requests",
    approved_label: "Approved",
    rejected_label: "Rejected",
    total_estimate: "Total Estimate",
    total_estimate_caption: "Total computed cost across all stages",
    total_estimate_short: "Total Est.",
    pending_approval: "Pending Approval",
    stage_types: "Stage Types",
    stage_types_distribution: "Stage type distribution",
    active_segments: "Active Segments",
    role_label: {
      superadmin: "Super Admin",
      aayda_chairman: "AAYDA Chairman",
      aayda_tech_supervision: "AAYDA — Tech Supervision",
      aayda_construction: "AAYDA — Construction",
      aayda_finance: "AAYDA — Finance",
      aayda_curator: "AAYDA — Curator",
      consulting_team_lead: "Team Lead",
      consulting_tech_office: "Technical Office",
      consulting_inspector: "Inspector",
      consulting_topographer: "Topographer",
      consulting_material_engineer: "Material Engineer",
      consulting_estimate_engineer: "Estimate Engineer",
      contractor: "Contractor",
    },
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("ytn_lang") || "az");

  useEffect(() => {
    localStorage.setItem("ytn_lang", lang);
  }, [lang]);

  const t = (key) => {
    const parts = key.split(".");
    let v = STRINGS[lang];
    for (const p of parts) {
      v = v?.[p];
    }
    return v ?? key;
  };

  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
